module.exports = __webpack_public_path__ + "img/qr.55e27cbf.png";